import { CsvHeaderModel } from '../../../models/CsvHeader';

export const RIDER_BALANCE_HEADER: CsvHeaderModel[] = [
  {
    label: 'ຊື່ຂອງຄົນຂັບ',
    key: 'username',
  },
  {
    label: 'ໝາຍເລກຜູ້ຂັບຂີ່',
    key: 'driverNo',
  },
  {
    label: 'ຈຳນວນເງີນທີ່ຖອກ',
    key: 'balanceSubmission',
  },
  {
    label: 'ເງີນທີ່ຄົນຂັບຈະຕ້ອງໄດ້',
    key: 'totalMoneyRiderGot',
  },
  {
    label: 'ຄ່າຊົດເຊີຍທັງໝົດທີ່ຄົນຂັບໄດ້ຮັບ',
    key: 'totalMoneyOrderReturn',
  },
  {
    label: 'ຈຳນວນເງິນທີ່ຄົນຂັບເຮັດໄດ້ທັງໜົດ',
    key: 'totalMoneyRiderCantake',
  },
  {
    label: 'ໄລຍະທາງທີ່ໄລເດີ້ເເລ່ນ',
    key: 'totalDistance',
  },
  {
    label: 'ຈຳນວນເງີນທັງໜົດ',
    key: 'totalMoney',
  },
  {
    label: 'ວັນທີ',
    key: 'createdAt',
  },
];
